export default function EntryTableRow({ entry }) {
  return (
    <tr>
      <td>{entry.name}</td>
      <td>{entry.description}</td>
      <td>${entry.price}</td>
    </tr>
  );
}
